var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0322 10.7977C13.119 10.7977 14 11.704 14 12.8221V13.34C14 14.1451 13.7203 14.9235 13.2115 15.5351C11.8382 17.1855 9.74946 18 6.99715 18C4.2444 18 2.15658 17.1853 0.786021 15.5341C0.278714 14.923 0 14.1457 0 13.342V12.8221C0 11.704 0.881022 10.7977 1.96783 10.7977H12.0322ZM12.0322 12.148H1.96783C1.60592 12.148 1.31254 12.4498 1.31254 12.8221V13.342C1.31254 13.8242 1.47977 14.2906 1.78416 14.6573C2.88083 15.9784 4.60103 16.6498 6.99715 16.6498C9.39324 16.6498 11.1149 15.9784 12.2144 14.6571C12.5197 14.2901 12.6875 13.823 12.6875 13.34V12.8221C12.6875 12.4498 12.3941 12.148 12.0322 12.148ZM6.99715 0C9.41345 0 11.3723 2.01508 11.3723 4.5008C11.3723 6.98654 9.41345 9.00163 6.99715 9.00163C4.5808 9.00163 2.62199 6.98654 2.62199 4.5008C2.62199 2.01508 4.5808 0 6.99715 0ZM6.99715 1.35024C5.30572 1.35024 3.93453 2.7608 3.93453 4.5008C3.93453 6.24082 5.30572 7.65139 6.99715 7.65139C8.68858 7.65139 10.0597 6.24082 10.0597 4.5008C10.0597 2.7608 8.68858 1.35024 6.99715 1.35024Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0376ec8ca47b4d0b2ae6381d4b8cb8a7.svg";
export { ForwardRef as ReactComponent };